







import { Component, Vue } from 'vue-property-decorator';
import { isDaytime } from './utils/sunCalc';
import ThemeToggle from '@/components/ThemeToggle.vue';

@Component({
  components: {
    ThemeToggle
  }
})
export default class App extends Vue {
  private updateTheme() {
    // Check if user has manually set a theme preference
    const override = localStorage.getItem('theme-override');

    if (override) {
      // User has manually selected a theme, respect it
      if (override === 'dark') {
        document.documentElement.classList.add('dark-theme');
      } else {
        document.documentElement.classList.remove('dark-theme');
      }
    } else {
      // Auto-detect based on time
      const isDay = isDaytime();
      if (isDay) {
        document.documentElement.classList.remove('dark-theme');
      } else {
        document.documentElement.classList.add('dark-theme');
      }
    }
  }

  mounted() {
    this.updateTheme();

    // Update theme every hour (only if no manual override)
    setInterval(() => {
      if (!localStorage.getItem('theme-override')) {
        this.updateTheme();
      }
    }, 60 * 60 * 1000);
  }
}
